module.exports = __webpack_public_path__ + "img/pay_state_duty_min.f19f8949.jpg";